import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

/**
 * Relance groupée d'envois AS400 en erreur (100 au plus).
 * retryTourLogs renvoie le résultat de l'API ({ retriedIds, skipped }) ou null en cas d'échec.
 */
export default function useRetryTourLogs() {
  const [isLoading, setIsLoading] = useState(false);

  const retryTourLogs = async (ids) => {
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/tours/tours-logs/retry', { ids });
      const { message, skipped = [] } = response.data;
      toast.success(
        skipped.length
          ? `${message} ${skipped.length} envoi${skipped.length > 1 ? 's' : ''} ignoré${skipped.length > 1 ? 's' : ''} (déjà relancé${skipped.length > 1 ? 's' : ''} ou plus en action requise).`
          : message
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Les nouveaux envois n’ont pas pu être demandés. Veuillez réessayer.'
      );
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, retryTourLogs };
}
